<script setup lang="ts">
import { computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const props = withDefaults(
  defineProps<{
    name: string;
    open?: boolean;
  }>(),
  { open: false },
);

const folderIcon = computed(() => (props.open ? 'folder-open' : 'folder'));
</script>

<template>
  <div class="ps-folder ps-ui-element">
    <div class="folder-title">
      <FontAwesomeIcon class="folder-icon" :icon="['fal', folderIcon]" fixed-width size="lg" />
      <span class="folder-name">{{ name }}</span>
    </div>
  </div>
</template>

<style scoped>
.ps-folder,
.folder-title {
  align-items: center;
  display: inline-flex;
}

.folder-title {
  gap: 0.35rem;
}

.folder-icon {
  display: block;
  flex: 0 0 1.25rem;
  height: 1.25rem !important;
  width: 1.25rem !important;
}
</style>
